import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");

  if (token === null || token === undefined) {
    // Redirect to login page if user is not authenticated
    return <Navigate to="/SIGNIN" replace />;
  }

  // Render the protected component if authenticated
  return children;
};

export default ProtectedRoute;
